import React from "react";
import { Link } from "react-router";
import { browserHistory } from "react-router";
import _ from "lodash";
import "../../sass/components/HeaderNavigation/HeaderNavigation.css";

function DropDownMenu(props) {
  /**Preload module locations, this would be loaded as a store/config component */
  // const menuLocations = [
  //   { title: "Parcels", url: "/concierge/parcel/checkin" },
  //   { title: "Keys", url: "" },
  //   { title: "Residents", url: "/concierge/residents/addnew" },
  //   { title: "Visitors", url: "" }
  // ];

  function menuClick(menu) {
    props.reset(true);

    browserHistory.push({
      pathname: "/",
      state: { module: menu }
    });
  }
  return (
    <div className="nav-wrapper">
      <nav id="subNav" className={`${props.sticky} ${props.visible}`}>
        <ul>
          {_.map(props.moduleList, (module, index) => {

            return (
              <li key={index}>
                <Link
                  onClick={e => menuClick(module.title)}
                  style={{ cursor: "pointer" }}
                >
                  {module.title}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
}

export default DropDownMenu;



// WEBPACK FOOTER //
// ./src/components/HeaderNavigation/DropDownMenu.js